import { css, StyleSheet } from "aphrodite";
import { COLORS } from "../../../../config/themes";

import Image from "../../../Image";
const AchievementBadge = ({ badgeStyles, iconStyles, achievement, index }) => {
  return (
    <div
      className={css(styles.badgeContainer, badgeStyles)}
      key={`acheivement_${index}`}
    >
      <Image
        imageSrc={"/static/trophy.webp"}
        className={css(styles.badgeIcon, iconStyles)}
        containerClassName={css(styles.iconContainer)}
        alt="Trophy Icon"
      />
      <span>{achievement}</span>
    </div>
  );
};

const styles = StyleSheet.create({
  badgeContainer: {
    color: "#fff",
    padding: "8px 24px",
    display: "flex",
    borderRadius: 52,
    background: "#E0F2FE",
    alignItems: "center",
    color: COLORS.BLACK(),
    padding: "7px 12px",
    fontWeight: 600,
    fontSize: 16,
    lineHeight: "28px",
  },
  iconContainer: {
    marginRight: 8,
    width: 22,
    height: 19,
  },
  badgeIcon: {
    background: "transparent",
  },
});
export default AchievementBadge;
